import { BrowserRouter as Router } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './Style/Max.Style.css';
import Interface from './Code/Interface.jsx';

ReactDOM.createRoot(
  document.getElementById('Root')
).render(
  <Router>
    <Interface />
  </Router>
);